///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2025
//                                RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { Fragment } from "react";

import SearchIcon from "./icons/SearchIcon";
import messages from "../helpers/messages";

const SearchBox = ({
  width = "230px",
  placeholder = messages.searchThisPage.defaultMessage,
  inputTitle,
  ...props
}) => (
  <Fragment>
    <label className="add-in" style={{ width: width }}>
      <SearchIcon
        className="add-in__right-item"
        fill="#343434"
        height="16px"
        title={messages.search.defaultMessage}
        width="16px"
      />
      <input
        className="card one-whole pl-12 pr-32 py-8 box--border-none search-box"
        placeholder={placeholder}
        type="text"
        {...props}
        title={inputTitle}
      />
    </label>
  </Fragment>
);

export default SearchBox;
